import '@/server/utils/setupEnv';

import { Environment } from '@/internals/env.config';

import { DeviceType } from './generateDownloadLink';

export const makeSchemaTarget = (env: Environment, device: DeviceType, baseUrl?: string): string | undefined => {
  if (!baseUrl) return undefined;
  try {
    const url = new URL(baseUrl);
    let newUrlRaw = `${env.electron.scheme}://${url.hostname}${url.pathname}${url.search}`;
    if (device === DeviceType.ANDROID) {
      newUrlRaw = `${env.deeplinksTld}${url.pathname}${url.search}`;
    }
    if (device === DeviceType.WEB) {
      newUrlRaw = `${env.config.APP_ORIGIN}${url.pathname}${url.search}`;
    }

    const newUrl = new URL(newUrlRaw);
    if (device === DeviceType.WEB) {
      newUrl.searchParams.append('showAuth', 'true');
    }
    return newUrl.toString();
  } catch (e) {
    return baseUrl;
  }
};
